export * from './hero';
export * from './content';
export * from './footer';
